import { inject, injectable } from "inversify";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { Channel } from "@/models/channel";
import { IChannelApi } from "./IChannelApi";

@injectable()
export class ChannelApi implements IChannelApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/channels";

  async getOrganizationChannels(organizationId: string): Promise<Channel[]> {
    const { data } = await this.client.get<Channel[]>(
      `${this.baseUrl}/organization/${organizationId}`
    );
    return data;
  }
}
